import "./App.scss";
import config from "./config.json";
import React, { useContext, useEffect, useReducer, useState } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import Protect from "react-app-protect";
import "react-app-protect/dist/index.css";

import Drawings from "./components/Drawings";
import EventPage from "./components/EventPage";
import StateContext from "./context/StateContext";
import styled, { createGlobalStyle, ThemeProvider } from "styled-components";
import InitialSplashScreen from "./components/InitialSplashScreen";
import Home from "./components/Home";
import WebcamCapture from "./components/WebcamCapture";
import CareHeader from "./components/Header";
import HomePageFooter from "./components/Footer";
import Menu from "./components/Menu";
import AudioPlayer from "./components/AudioPlayer";
import ReactAudioContext from "./context/ReactAudioContext";

const INITIAL_STATE = {
  showSplashScreen: true,
  watchedVideos: 0,
  watchedRickrolledVideos: 0,
  numEventPagesVisited: 0,
  userImage: null,
  captureNewImage: true,
  numPagesVisited: 0,
  audioValue: 0,
};

function stateReducer(state, action) {
  switch (action.type) {
    case "hasShownSplashScreen": {
      return { ...state, showSplashScreen: false };
    }
    case "watchedVideo": {
      return { ...state, watchedVideos: state.watchedVideos + 1 };
    }
    case "watchedRickrolledVideo": {
      return {
        ...state,
        watchedVideos: state.watchedVideos + 1,
        watchedRickrolledVideos: state.watchedRickrolledVideos + 1,
      };
    }
    case "setUserImage": {
      return { ...state, userImage: action.payload, captureNewImage: false };
    }
    case "captureNewImage": {
      return { ...state, captureNewImage: true };
    }
    case "incrementPagesVisited": {
      return { ...state, numPagesVisited: state.numPagesVisited + 1 };
    }
    case "updateAudioValue": {
      return { ...state, audioValue: action.payload };
    }
    default: {
      console.warn("Not a valid stateReducer action type: " + action.type);
      return state;
    }
  }
}

const GlobalStyle = createGlobalStyle`
body {
  background: ${(props) => props.theme.background};
}
`;

const BgContainer = styled.div`
  background: linear-gradient(
    210deg,
    ${(props) => props.theme.primary},
    ${(props) => props.theme.background} 30%
  );
`;

function PageContentContainer(props) {
  return (
    <Switch>
      {config.data.map((item) => (
        <Route path={"/" + item.index} key={item.index}>
          <EventPage media={item}></EventPage>
        </Route>
      ))}
      <Route path="/dad">
        {/* <Protect sha512="5048D4C410BB685DB2390C4F6CCE868F6D0C979651B323530D15F8133A8A6FC7B9BBE51BB380B0C858935014152296B335ADBF775EF260C2D9C40DD37771E4D2"> */}
        <EventPage media={config.fred}></EventPage>
        {/* </Protect> */}
      </Route>
      <Route path="/">
        <Home config={config}></Home>
      </Route>
    </Switch>
  );
}

function CountPageViews(props) {
  const location = useLocation();
  const [, dispatch] = useContext(StateContext);

  useEffect(() => {
    dispatch({ type: "incrementPagesVisited", payload: location });
  }, [location, dispatch]);
  return null;
}

function BackgroundedApp({ config, ...props }) {
  return (
    <BgContainer>
      <CareHeader headerConfig={config.header}></CareHeader>
      <Menu menuConfig={config.menu}></Menu>
      <PageContentContainer></PageContentContainer>
      <HomePageFooter></HomePageFooter>
    </BgContainer>
  );
}

function App() {
  const [audioContext, setAudioContext] = useState(null);
  const [splashScreenText] = useState(
    config.quotes.generatedLong.concat(config.quotes.klein)[
      Math.floor(
        Math.random() *
          (config.quotes.generatedLong.length + config.quotes.klein.length)
      )
    ]
  );
  const reducer = useReducer(stateReducer, INITIAL_STATE);
  return (
    <ThemeProvider theme={config.theme.bgp}>
      <ReactAudioContext.Provider value={audioContext}>
        <StateContext.Provider value={reducer}>
          <CountPageViews></CountPageViews>
          <AudioPlayer audioFile={config.audio.path}></AudioPlayer>
          <GlobalStyle></GlobalStyle>
          <InitialSplashScreen
            setAudioContext={setAudioContext}
            text={splashScreenText}
            {...config.splashScreen}
          ></InitialSplashScreen>
          <BackgroundedApp config={config}></BackgroundedApp>
          <WebcamCapture></WebcamCapture>
          <Drawings drawings={config.drawings}></Drawings>
        </StateContext.Provider>
      </ReactAudioContext.Provider>
    </ThemeProvider>
  );
}

export default App;
